import type { FaireProductEntity } from "../../entity_types/product";

export const p_2hmv6raml2: FaireProductEntity = {
  token: "p_2hmv6raml2",
  type: "product",
  name: "Chamomile Dream Tin & Spoon - Fair-Trade, Calming Herbal Tea",
  brandToken: "b_cwa13pfnx9",
  brandName: "JusTea (No Import Fees to USA)",
  imageUrl:
    "https://cdn.faire.com/fastly/afa18c694dbd53b8ac25ecc4b3329ab6775fcaddb43a99099bc5566d5a33c791.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f1628855e8278c80aba237cabb567de5e29e3f8932e71133735f110dd1a0f784.jpeg",
    "https://cdn.faire.com/fastly/aabbcb00842d88c94a02a2b560e7068948ded98df9829f72cc3ad8d0504b50de.jpeg",
    "https://cdn.faire.com/fastly/e783ecd5bdc45c42917932af70dc252e7829361dc033ba8bcedf384239cb693e.jpeg",
    "https://cdn.faire.com/fastly/a0d105df13dd2bac7bcbb4b03b728d33b751c37ec18fea8154965ab1cb9fc92a.jpeg",
    "https://cdn.faire.com/fastly/8c4adc743fdc0d4b1f9c16ac585b5f761f5d7dca2c4f2d635021fe8d0bb2889e.jpeg",
    "https://cdn.faire.com/fastly/2a312fb2a94535ab5682b3e4e27ac2f9a9a2dc818e3d7eb0f19c43727f17be3d.jpeg",
    "https://cdn.faire.com/fastly/9a1f7029a457e2ce1107589003e14576b48b6eec9442e79592e6ac5a27a08c90.jpeg",
    "https://cdn.faire.com/fastly/d6b794b30bd07c829bb5f8c3742650769c26c7afbec199d9375634a40be7f7d9.jpeg",
    "https://cdn.faire.com/fastly/c7c63ab10c8ca37e71a8a8a41cfec27181b3a2d13879df8fe716bca05b9ee60b.jpeg",
    "https://cdn.faire.com/fastly/9f1a0a687b7c4db8a545ebc652fc54257fad04faf7e535ca4eb479407ba5af54.jpeg",
  ],
  priceDollars: 9.99,
  description:
    "WHY CUSTOMERS LOVE JUSTEA: Award-winning taste, stand-out packaging, and a farmer-direct story!\n\nCHAMOMILE DREAM is Calming & Smooth with notes of Honey & Flower Blossoms.\n\nSTAND-OUT PACKAGING: Beautiful tea tins with the farmer's picture/profile, hand-carved Kenyan spoon, and a viewing window in the lid. \n\nFARMER-DIRECT STORY: Every purchase directly supports a Women’s Herbal Tea Co-op in Kenya. Justly Made Tea.\n\nHAND-CARVED SPOON: Attached to each tin is a handcrafted, olive-wood tea spoon! Creating sustainable employment for Kenyan artisans.\n\nEARTH-FRIENDLY: Each tin is recyclable or reusable and offers up to 80 cups of loose leaf tea.\n\nHAND-PICKED TEA from Kenya: Organically grown, free of chemicals and pesticides. Non-GMO. Proud member of Fair Trade Federation.\n\n100% NATURAL INGREDIENTS: Organic Chamomile Blossoms, Organic Lemongrass, Organic Licorice Root (Gluten/Sugar-Free and Caffeine-Free).\n\n2 YEAR SHELF LIFE Guaranteed.",
  tags: [],
  msrpDollars: 19.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:43.235Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
